// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill"
import Vue from 'vue'
import router from './router'
import VueResource from 'vue-resource'
import ElementUI from 'element-ui'
import $ from 'jquery'
import App from './App'
import '../static/common.css'

var websdk = require('easemob-websdk')
let webIM = window.WebIM = websdk

Vue.prototype.$WebIM = webIM
const imConn = new webIM.connection({
  isMultiLoginSessions: webIM.config.isMultiLoginSessions,
  https: typeof webIM.config.https === 'boolean' ? webIM.config.https : location.protocol === 'https:',
  url: webIM.config.xmppURL,
  isAutoLogin: true,
  heartBeatWait: webIM.config.heartBeatWait,
  autoReconnectNumMax: webIM.config.autoReconnectNumMax,
  autoReconnectInterval: webIM.config.autoReconnectInterval,
  apiUrl: webIM.config.apiURL
})
Vue.prototype.$imConn = imConn

function setCookie(name, value){
  var Days = 2;
  var exp = new Date();
  exp.setTime(exp.getTime()+Days*24*60*60*1000);
  // document.cookie = name + "=" + escape(value) ;
  document.cookie = name + "="+ escape(value) +";path=/;expires="+ exp.toGMTString();
}

Vue.use(VueResource);
Vue.use(ElementUI)
Vue.http.interceptors.push(function (request, next) { //拦截器
  request.credentials = false;
  next((res) => {
    //401 登录过期跳转
    if (res.data.status == 401) {
      router.push("/login");
      setCookie('sessionId', '')
      setCookie('objectParam', '')
    }
  })
})

Vue.config.productionTip = false


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})


// WEBPACK FOOTER //
// ./src/main.js